export const SHELLS_MAP = {
  MVP_DESKTOP_SHELL: 'MVP_DESKTOP_SHELL',
  MVP_MOBILE_SHELL: 'MVP_MOBILE_SHELL',
  SC_DESKTOP_SHELL: 'SC_DESKTOP_SHELL',
  SC_MOBILE_SHELL: 'SC_MOBILE_SHELL',
};

export const DEFAULT_LAYOUT_DIMENSIONS = {
  top: '0px',
  left: '0px',
  right: '0px',
  bottom: '0px',
};

export const LAYOUT_DIMENSIONS_BY_SHELL_MAP = {
  [SHELLS_MAP.MVP_DESKTOP_SHELL]: {
    top: '48px',
    left: '0px',
    right: '0px',
    bottom: '0px',
  },
  [SHELLS_MAP.MVP_MOBILE_SHELL]: {
    top: '44px',
    left: '0px',
    right: '0px',
    bottom: '56px',
  },
  [SHELLS_MAP.SC_MOBILE_SHELL]: {
    top: '56px',
    right: '0px',
    bottom: '57px',
    left: '0px',
  },
  [SHELLS_MAP.SC_DESKTOP_SHELL]: {
    top: '56px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  },
};

export const CLASS_NAME_BY_SHELL_MAP = {
  [SHELLS_MAP.MVP_DESKTOP_SHELL]: 'mvp-shell',
  [SHELLS_MAP.MVP_MOBILE_SHELL]: 'mvp-shell',
};
